import { IOrganizationData } from "./actions";

export const getProfileMapSelector = (state: any) => { 
    return state?.profile?.profileMap || {};
} 

export const getcurrentLoggedinUserprofileIdSelector = (state: any) => { 
    return state?.profile?.currentLoggedinUserprofileId || "";
}
export const getupdateProfileLoaderSelector = (state: any): boolean => {
    return state?.profile?.loaders?.updateProfile || false;
};
  
export const getupdateProfileErrorSelector = (state: any): string => {
  return state?.profile?.errors?.updateProfile || "" ;
};

export const getIsLoggedInUserProfileCompletedSelector = (state: any): boolean => {
    return state?.profile?.isLoggedInUserProfileCompleted || false ;
};

export const getRegisterOrganizationLoaderSelector = (state: any): boolean => state.profile.loaders.registerOrganization ?? false;

export const getRegisterOrganizationErrorSelector = (state: any): string => state.profile.errors.registerOrganization ?? "";

export const getLoggedInUserOrganizationDataSelector = (state: any):IOrganizationData => { 
    return state?.profile?.organizationData || {};
} 

export const getUpdateOrganizationLoaderSelector = (state: any): boolean => state.profile.loaders.updateOrganization ?? false;
export const getUpdateOrganizationErrorSelector = (state: any): string => state.profile.errors.updateOrganization ?? "";
